export default __webpack_public_path__ + "static/logo-484ab23e5e090cf6afed82d3df082b7b.svg";